import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import TanstackTable from "../../../Components/Table/TanstackTable";

const RenewalReminder = () => {
  const selectedFilter = useSelector(
    (state) => state.filtersPvin.selectedFilter
  );
  const RenewalReminderApi = async (selectedFilter) => {
    try {
      const res = await axInst.post("pvin/remainder_service", selectedFilter);
      return res.data;
    } catch (error) {
      console.error("Error fetching fleet details:", error.response || error);
      throw error;
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Hygiene Reminder",
        accessorKey: "Hygiene_Reminder_Name",
        cell: ({ getValue }) => (
          <div className="text-left">{getValue() || "N/A"}</div>
        ),
      },
      { header: "Current Month", accessorKey: "Current" },
      { header: "Next Month", accessorKey: "Next" },
    ],
    []
  );

  return (
    <TanstackTable
      heading="Renewal Reminders"
      columns={columns}
      apiFn={RenewalReminderApi}
      queryKey="RenewalReminder"
      filter={selectedFilter}
      theadColor="bg-white"
      height="max-h-[250px]"
      theadCss="text-gray-700 font-semibold text-lg text-left"
      border=""
    />
  );
};

export default RenewalReminder;
